export * from './lib/commonjs/svg.js';
